import { datadogRum } from '@datadog/browser-rum';

export function reportError(error: any, context?: object) {
  datadogRum.addError(error, context);
}
